import { render, staticRenderFns } from "./DecisionFinance.vue?vue&type=template&id=245af5ae&"
import script from "./DecisionFinance.vue?vue&type=script&lang=js&"
export * from "./DecisionFinance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports